//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { SubtitleText } from '@components/atoms/text/Text';

interface Props {
  children: React.ReactNode;
  className?: string;
  icon: React.ReactNode;
  title: string;
}

export const OnboardingInfoCard = ({
  children,
  className,
  icon,
  title,
}: Props) => {
  return (
    <CardContainer>
      <ContentContainer className={className}>
        <TitleContainer>
          <SubtitleText>{title}</SubtitleText>
        </TitleContainer>
        {children}
      </ContentContainer>
      {icon}
    </CardContainer>
  );
};

const CardContainer = styled.div(
  ({ theme }) => `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: ${theme.spacings[5]};
  background-color: ${theme.colors.white};
  box-shadow: ${theme.boxShadows[2]};
`,
);

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
